import React from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import RuleIcon from "@mui/icons-material/Rule";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import { useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
import { gql } from "graphql-request";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { addQuoteService } from "../../../lib/appUtliz/QuoteService";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";
import { useNavigate } from "react-router-dom";
const wonOption = [
  {
    id: 1,
    value: "Best Product",
  },
  {
    id: 2,
    value: "Best Price ",
  },
  {
    id: 3,
    value: "Relationship ",
  },
  {
    id: 4,
    value: "Other",
  },
];

const LossOption = [
  {
    id: 1,
    value: "Price is too high.",
  },
  {
    id: 2,
    value: "Junk  ",
  },
  {
    id: 3,
    value: "Not Interested  ",
  },
  {
    id: 4,
    value: "No Requirement ",
  },
  {
    id: 4,
    value: "Other ",
  },
];
const status = [
  {
    id: 1,
    status: "win",
  },
  {
    id: 2,
    status: "loss",
  },
];

const QuoteStatus = () => {
  const [statusOption, setStatusOption] = useState([]);
  const [statusData, setStatusData] = useState({
    // Brand Details
    status: "",
    reason: "",
    closedDate: "",

    // Brand Type Status
    statusStatus: "unchecked",
    reasonStatus: "unchecked",
    closedDateStatus: "unchecked",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);

  const handleChange = (event, selectEvent) => {
    let statusState = { ...statusData };
    const changeAllowed = true;
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "status":
          {
            if (event?.label == "win") {
              setStatusOption(wonOption);
            } else if (event?.label == "loss") {
              setStatusOption(LossOption);
            } else {
              setStatusOption([]);
            }
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              statusState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              statusState["reason"] = "";
              statusState["reasonStatus"] = "unchecked";
            } else {
              statusState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              setStatusOption([]);
              statusState["reason"] = "";
              statusState["reasonStatus"] = "unchecked";
            }
          }
          break;
        case "reason":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              statusState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              statusState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      statusState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "closedDate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              statusState[event.target.name + "Status"] = "success";
            } else {
              statusState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        statusState[event.target.name] = event.target.value;
      }
    }
    setStatusData(statusState);
  };

  const handleSumbit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        const lowercase = statusData.status?.label;
        const values = {
          user: currentUser?.id,
          quotation: id,
          status: lowercase,
          reason: statusData.reason?.label,
          closingdate: statusData.closedDate,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const status = await addQuoteService(values);
        setCirleLoading(false);
        setSuccessStatus(true);
        setTimeout(() => {
          setSuccessStatus(false);
          navigate("/quotation");
        }, 2000);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Change Won / Loss
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1}>
            <RuleIcon style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Change Won / Loss (QuoteId)
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="status"
                  value={statusData.status}
                  //   defaultValue={{ label: "Please select" }}
                  //   customStyles={{ optionPadding: 20 }}
                  onChange={handleChange} //selectedValue, event
                  options={status.map((value) => {
                    return {
                      value: value.id,
                      label: value.status,
                    };
                  })}
                  error={statusData.statusStatus === "error" ? true : false}
                  success={statusData.statusStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  value={statusData.reason}
                  //   defaultValue={{ label: "Please select" }}
                  //   customStyles={{ optionPadding: 20 }}
                  onChange={handleChange} //selectedValue, event
                  options={statusOption.map((value) => {
                    return {
                      value: value.id,
                      label: value.value,
                    };
                  })}
                  error={statusData.reasonStatus === "error" ? true : false}
                  success={statusData.reasonStatus === "success" ? true : false}
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Closed Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="closedDate"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={statusData.closedDate}
                  onChange={handleChange}
                  error={statusData.closedDateStatus === "error" ? true : false}
                  success={
                    statusData.closedDateStatus === "success" ? true : false
                  }
                />
                {statusData.closedDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleSumbit}
              >
                Submit
              </MaterialButton>
              <MaterialButton sx={{ m: 2 }} variant="gradient" color="dark">
                Cancel
              </MaterialButton>
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default QuoteStatus;
